import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import React from 'react'

import { CustomListItem } from './utils/list-item'

export const listItem: NodeRenderer = (node, children) => (
  <CustomListItem>{children}</CustomListItem>
)
